import React from 'react';
import PropTypes from 'prop-types';
import './Movie.css';
function Movie({year, title, summary, poster, genres}){
    return (
        <div className="movie">
            <img src={poster} alt={title} title={title}/>
            <div className="movie_data">
                <h3 className="movie__title">{title}</h3>
                <h5 className="movie__year" >{year}</h5>
                <ul className="genres">{genres.map( (genre, index) => <li key= {index} className="genres__genre">{genre}</li>)}</ul>
                <p className="movie__summary">{summary.slice(0, 140)}...</p>
            </div>
        </div>
    )
}
//state가 필요없다면 class 컴포넌트로 만들지 않고 function형태로 만들어주어도 된다.

Movie.propTypes = {
    id:PropTypes.number.isRequired,
    year:PropTypes.number.isRequired,    
    title:PropTypes.string.isRequired,
    summary:PropTypes.string.isRequired,
    poster:PropTypes.string.isRequired,
    genres:PropTypes.arrayOf(PropTypes.string).isRequired
};

export default Movie;